function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "btn-scroll-to-top_inline_svg__vrwo72a3xa",
  width: "195.8%",
  height: "195.8%",
  x: "-47.9%",
  y: "-47.9%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.195073892 0 0 0 0 0.204926108 0 0 0 0 0.197044335 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  filter: "url(#btn-scroll-to-top_inline_svg__vrwo72a3xa)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.834 0C10.671 0 0 10.67 0 23.834c0 13.163 10.67 23.834 23.834 23.834 13.163 0 23.834-10.67 23.834-23.834C47.668 10.671 36.998 0 23.834 0zM10.228 11.887c.18-.015.361-.015.541 0H33.46c.178-.01.355-.01.533 0a4.092 4.092 0 013.752 3.744c0 .183 0 .226-.279.261a3.27 3.27 0 01-.54.044H14.233c-.18.01-.36.01-.54 0a4.103 4.103 0 01-3.754-3.744c.01-.227.01-.27.288-.305zm13.615 16.765c-5.088 5.088-10.752 7.13-15.831 7.173l15.83-15.822 15.823 15.822c-5.079-.043-10.734-2.085-15.822-7.173z"
}));

function SvgBtnScrollToTopinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref, _ref2);
}

export default SvgBtnScrollToTopinline;